export async function handleImageUpload(evt, check_page) {
    let allowedExtensions = ["jpg", "jpeg", "png", "gif", "mp4", "mkv", "webm", "avi", "flv", "wmv", "mov"];
    let file_ext = evt.value.substr(evt.value.lastIndexOf('.')+1,evt.value.length);
    if (!allowedExtensions.includes(file_ext)) {
        alert('Only image file with extension: .jpg, .jpeg, .gif, .mp4, .mkv, .avi, or .png is allowed');
        evt.value = '';
        return false;
    }
    else {
        defaultLoader();
        var imageFile = [...evt.files]
        let list = new DataTransfer();
        var options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        await $.each(imageFile, async function (index) {
            var ext = imageFile
            await imageCompression(this, options)
                .then(function (compressedFile) {
                    var myFile = new File([compressedFile], `new_${compressedFile.name}`, {type: `${compressedFile.type}`});
                    imageFile[index] = myFile
                })
        })
        setTimeout(function () {
            $.each(imageFile, function () {
                list.items.add(this);
            })
            if (list.files[0].size > 8000000) {
                alert("File is too big! Kindly upload file less than 8-MB");
                JsLoadingOverlay.hide();
                evt.value = "";
            } else {
                evt.files = list.files
                JsLoadingOverlay.hide();
                if (check_page === 'new_provider')
                {
                    readURL(evt);
                }
                else if (check_page === 'edit_provider'){
                    readURL(evt);
                    $("#remove_dp").val(true);
                }
                else{
                    readImgUrlAndPreview(evt)
                    $("#imageAdded").val('true');
                    $("#remove_dp").val('true');
                }
            }
        }, 5000);

    }
}
